"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _reactMaskedinput = _interopRequireDefault(require("react-maskedinput"));

var _Control = _interopRequireDefault(require("@icare/rhythm-form-react/lib/elements/Control"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChangeRaw", function (input) {
      var inputValue = input.target.value;
      var _this$props = _this.props,
          onChangeListener = _this$props.onChangeListener,
          onChange = _this$props.onChange;
      var regex = /(\d{2}\/\d{2}\/\d{4})/;

      if (regex.test(inputValue)) {
        if (onChangeListener) {
          onChangeListener(inputValue);
        }

        onChange(inputValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (selectedDate) {
      var _this$props2 = _this.props,
          dateFormat = _this$props2.dateFormat,
          onChangeListener = _this$props2.onChangeListener,
          onChange = _this$props2.onChange;

      if (selectedDate) {
        var formatedDate = selectedDate.format(dateFormat);

        if (onChangeListener) {
          onChangeListener(formatedDate);
        }

        onChange(formatedDate);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "escFunction", function (event) {
      if (event.keyCode === 27) {
        _this._calendar.setOpen(false);
      }
    });

    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.escFunction, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.escFunction, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          label = _this$props3.label,
          tooltip = _this$props3.tooltip,
          status = _this$props3.status,
          statusMessage = _this$props3.statusMessage,
          helpText = _this$props3.helpText,
          inputFormatSuggestion = _this$props3.inputFormatSuggestion,
          placeholder = _this$props3.placeholder,
          inlinePlaceholder = _this$props3.inlinePlaceholder,
          required = _this$props3.required,
          dateFormat = _this$props3.dateFormat,
          error = _this$props3.error,
          width = _this$props3.width,
          labelProps = _this$props3.labelProps,
          attr = _objectWithoutProperties(_this$props3, ["label", "tooltip", "status", "statusMessage", "helpText", "inputFormatSuggestion", "placeholder", "inlinePlaceholder", "required", "dateFormat", "error", "width", "labelProps"]);

      var _status = status;
      var _statusMessage = statusMessage;

      if (error) {
        _status = 'error';
        _statusMessage = error;
      }

      var inputClasses = (0, _classnames.default)({
        error: _status === 'error'
      });
      var optional = {};

      if ((0, _moment.default)(this.props.value, this.props.dateFormat).isValid()) {
        optional.selected = (0, _moment.default)(this.props.value, this.props.dateFormat);
      }

      return /*#__PURE__*/_react.default.createElement(_Control.default, {
        name: this.props.id,
        label: label,
        status: _status,
        statusMessage: _statusMessage,
        helpText: helpText,
        labelProps: labelProps,
        tooltip: tooltip,
        required: required,
        inputFormatSuggestion: inputFormatSuggestion,
        placeholder: placeholder,
        width: width
      }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
        ref: function ref(c) {
          return _this2._calendar = c;
        },
        customInput: /*#__PURE__*/_react.default.createElement(_reactMaskedinput.default, {
          mask: "11/11/1111",
          size: "6",
          onChange: this.handleChangeRaw,
          calendar: this._calendar
        }),
        className: inputClasses,
        onChange: this.handleChange,
        onSelect: this.handleSelect,
        onChangeRaw: this.handleChangeRaw,
        value: this.props.value,
        id: this.props.id,
        name: this.props.id,
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select",
        preventOpenOnFocus: true,
        dateFormat: dateFormat // Not recommended. See EST21-2171
        ,
        placeholderText: inlinePlaceholder,
        disabledKeyboardNavigation: false,
        popperModifiers: {
          offset: {
            enabled: true
          }
        }
      }, optional, attr)));
    }
  }]);

  return DatePicker;
}(_react.default.Component);

exports.default = DatePicker;

_defineProperty(DatePicker, "propTypes", {
  label: _propTypes.default.node,
  tooltip: _propTypes.default.node,
  status: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']),
  statusMessage: _propTypes.default.node,
  helpText: _propTypes.default.node,
  labelProps: _propTypes.default.object,
  placeholder: _propTypes.default.string,
  inlinePlaceholder: _propTypes.default.string,
  inputFormatSuggestion: _propTypes.default.string,
  defaultPlaceholder: _propTypes.default.bool,
  required: _propTypes.default.bool,
  dateFormat: _propTypes.default.string,
  error: _propTypes.default.string,
  width: _propTypes.default.string,
  popperPlacement: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onChangeListener: _propTypes.default.func,
  value: _propTypes.default.string,
  id: _propTypes.default.string
});

_defineProperty(DatePicker, "defaultProps", {
  dateFormat: 'DD/MM/YYYY',
  popperPlacement: 'top-end',
  label: undefined,
  tooltip: undefined,
  status: undefined,
  statusMessage: null,
  helpText: undefined,
  placeholder: null,
  inlinePlaceholder: '',
  inputFormatSuggestion: '',
  defaultPlaceholder: false,
  required: false,
  error: null,
  width: null,
  onChange: function onChange() {},
  onChangeListener: function onChangeListener() {},
  value: null,
  id: null,
  labelProps: {}
});
//# sourceMappingURL=DatePicker.js.map